import { useEffect } from 'react'

import { PlanFrequency } from '../../constants'
import { useRegisterLockEvent } from '../../hooks'
import { LockEventName } from '../../types'
import { ChooseFrequencyLaterStepsContent_OfferLockDataFragment } from './components/steps-content/__generated__/choose-frequency-later-steps-content.graphql'
import { useChooseOfferFrequencyLaterContext } from './context-provider'

interface UseChooseFrequencyLaterSendLockEventProps {
  offerLockData: ChooseFrequencyLaterStepsContent_OfferLockDataFragment
}

export const useChooseFrequencyLaterSendLockEvent = ({
  offerLockData,
}: UseChooseFrequencyLaterSendLockEventProps) => {
  const { registerLockEvent } = useRegisterLockEvent()
  const { selectedPlanOffers, hasYearlyOffers, hasMonthlyOffers } =
    useChooseOfferFrequencyLaterContext()

  const initialCardOffers = offerLockData?.body?.cards
    ?.filter((card) => {
      const frequencyToFilter = hasYearlyOffers ? PlanFrequency.YEARLY : PlanFrequency.MONTHLY
      return card.offer.frequency === frequencyToFilter
    })
    .filter((card, index, self) => index === self.findIndex((c) => c.title === card.title))

  useEffect(() => {
    initialCardOffers.forEach((card) =>
      registerLockEvent({
        eventName: LockEventName.LOCK_VIEW,
        eventProperties: [card.lockEventProperties],
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!selectedPlanOffers.length) return

    const monthlyOffer = selectedPlanOffers.find(
      (planOffer) => planOffer.offer.frequency === PlanFrequency.MONTHLY
    )
    if (!monthlyOffer || !!initialCardOffers.find((card) => card.title === monthlyOffer?.title)) {
      return
    }

    registerLockEvent({
      eventName: LockEventName.LOCK_VIEW,
      eventProperties: [monthlyOffer.lockEventProperties],
    })
  }, [initialCardOffers, hasYearlyOffers, hasMonthlyOffers, selectedPlanOffers, registerLockEvent])

  return
}
